import { connect } from 'react-redux';
import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import { SharedMaterialRequestComponentBase, getSharedMaterialRequestState } from './SharedMaterialRequestComponentBase';

import * as Utilities from '../../utilities/Utilities';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';

type SharePassportParams = { sharedMaterialId: string };

class ShareMaterial extends SharedMaterialRequestComponentBase  {

    // ===============================================================================

    protected getLocalizedTitle(): string {
        return this.localizeString("Share Material");
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderForm(): JSX.Element {
        const routeParams = this.getRouteParams<SharePassportParams>();

        const urlToShare = `https://${window.location.host + ToxnotReactComponentPaths.SharedMaterialBaseDetailPath}/${routeParams.sharedMaterialId}`

        return ( 
            <div className="share-material-form">         
                <div className="share-material-body">
                    <div style={{ clear: "both" }} className="form-group">
                        <label htmlFor="share-email-url-to-copy-signed-out">{this.localizeString("Copy this URL to Share")}</label>
                        <div className="input-group">
                            <input id="shared-material-link-to-copy" type="text" className="form-control" value={urlToShare} disabled />
                            <span className="input-group-btn">
                                <button onClick={e => Utilities.copyContentFromHTMLInputElementToClipboard(document.getElementById("shared-material-link-to-copy") as HTMLInputElement)} className="btn btn-default copy-url-button" type="button">{this.localizeString("Copy")}</button>
                            </span>
                        </div>
                    </div>
                    <div className="form-group">
                        <div><p>{this.localizeString("Or we can send an email for you with an optional message.")}</p></div>
                        <label htmlFor="share-email-to-address">To:</label> (Comma Separated)
                        <input type="text" id="share-email-to-address" className="form-control" placeholder={this.localizeString("Email Addresses")} />
                        <br />
                        <label htmlFor="share-email-message">{this.localizeString("Message:")}</label>
                        <textarea id="share-email-message" className="form-control" rows={5}></textarea>
                    </div>
                </div>
            </div>
         );
    }


    // ===============================================================================

    protected getLocalizedDescription() {
        return this.localizeString("Share this material either by copying the link or by email");
    }

    // ===============================================================================

    protected submitButton_click = () => {
        const emailText = (document.getElementById("share-email-to-address") as HTMLInputElement).value.trim();

        const emailAddresses = emailText.split(',').map(s => s.trim()).filter(s => s.length > 0);

        if (emailAddresses.length === 0) {
            alert(this.localizeString("Please provide at least one email address."));
            return;
        }

        const message = (document.getElementById("share-email-message") as HTMLTextAreaElement).value;

        const sharedMaterialId = this.getRouteParams<SharePassportParams>().sharedMaterialId;

        this.props.shareMaterialByEmail(emailAddresses, message, sharedMaterialId);
    }
}

// ===============================================================================

export default connect(
    getSharedMaterialRequestState,
    SharedMaterialsDatabaseStateController.actionCreators // Selects which action creators are merged into the component's props
)(ShareMaterial as any);